/**
 * Master Data API Service
 * 
 * Handles all API calls related to master data
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  PRODUCTS: '/master-data/products',
  PRODUCT_BY_ID: (id) => `/master-data/products/${id}`,
  PRODUCTS_WITH_ATTRIBUTES: '/master-data/products/with-attributes',
  SUPPLIERS: '/master-data/suppliers',
  SUPPLIER_BY_ID: (id) => `/master-data/suppliers/${id}`,
  STORES: '/master-data/stores',
  ACTIVE_STORES: '/master-data/stores/active',
  STORE_BY_ID: (id) => `/master-data/stores/${id}`,
  WAREHOUSES: '/master-data/warehouses',
  ACTIVE_WAREHOUSES: '/master-data/warehouses/active',
  WAREHOUSE_BY_ID: (id) => `/master-data/warehouses/${id}`,
  LOCATIONS: '/master-data/locations',
  LOCATION_BY_ID: (id) => `/master-data/locations/${id}`,
  PRODUCT_SUPPLIER_DATA: '/master-data/product-supplier-data',
  INVENTORY_STATISTICS: '/master-data/inventory-statistics',
};

/**
 * Master Data API functions
 */
export const masterDataService = {
  // Products
  getProducts: () => api.get(ENDPOINTS.PRODUCTS),
  getProductById: (id) => api.get(ENDPOINTS.PRODUCT_BY_ID(id)),
  createProduct: (data) => api.post(ENDPOINTS.PRODUCTS, data),
  updateProduct: (id, data) => api.put(ENDPOINTS.PRODUCT_BY_ID(id), data),
  deleteProduct: (id) => api.delete(ENDPOINTS.PRODUCT_BY_ID(id)),
  getProductsWithAttributes: (params = {}) => api.get(ENDPOINTS.PRODUCTS_WITH_ATTRIBUTES, { params }),
  
  // Suppliers
  getSuppliers: () => api.get(ENDPOINTS.SUPPLIERS),
  getSupplierById: (id) => api.get(ENDPOINTS.SUPPLIER_BY_ID(id)),
  createSupplier: (data) => api.post(ENDPOINTS.SUPPLIERS, data),
  updateSupplier: (id, data) => api.put(ENDPOINTS.SUPPLIER_BY_ID(id), data),
  deleteSupplier: (id) => api.delete(ENDPOINTS.SUPPLIER_BY_ID(id)),
  
  // Stores
  getStores: () => api.get(ENDPOINTS.STORES),
  getActiveStores: () => api.get(ENDPOINTS.ACTIVE_STORES),
  getStoreById: (id) => api.get(ENDPOINTS.STORE_BY_ID(id)),
  createStore: (data) => api.post(ENDPOINTS.STORES, data),
  updateStore: (id, data) => api.put(ENDPOINTS.STORE_BY_ID(id), data),
  deleteStore: (id) => api.delete(ENDPOINTS.STORE_BY_ID(id)),
  
  // Warehouses
  getWarehouses: () => api.get(ENDPOINTS.WAREHOUSES),
  getActiveWarehouses: () => api.get(ENDPOINTS.ACTIVE_WAREHOUSES),
  getWarehouseById: (id) => api.get(ENDPOINTS.WAREHOUSE_BY_ID(id)),
  createWarehouse: (data) => api.post(ENDPOINTS.WAREHOUSES, data),
  updateWarehouse: (id, data) => api.put(ENDPOINTS.WAREHOUSE_BY_ID(id), data),
  deleteWarehouse: (id) => api.delete(ENDPOINTS.WAREHOUSE_BY_ID(id)),
  
  // Locations
  getLocations: () => api.get(ENDPOINTS.LOCATIONS),
  getLocationById: (id) => api.get(ENDPOINTS.LOCATION_BY_ID(id)),
  createLocation: (data) => api.post(ENDPOINTS.LOCATIONS, data),
  updateLocation: (id, data) => api.put(ENDPOINTS.LOCATION_BY_ID(id), data),
  deleteLocation: (id) => api.delete(ENDPOINTS.LOCATION_BY_ID(id)),
  
  // Product-Supplier Data
  getProductSupplierData: () => api.get(ENDPOINTS.PRODUCT_SUPPLIER_DATA),
  
  // Inventory Statistics
  getInventoryStatistics: () => api.get(ENDPOINTS.INVENTORY_STATISTICS),
}; 